import { KPIGoal, KPIOption } from '@/api/kpi'
import { IconCross } from '@tabler/icons-react'
import { FC } from 'react'

import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Branch } from '@/types'

interface IKPITableProps {
  goals: KPIGoal[]
  kpiOptions: KPIOption[]
  branches: Branch[]
  handleRemoveKPI: (id: string | number) => void
}

const KPITable: FC<IKPITableProps> = ({
  goals,
  kpiOptions,
  branches,
  handleRemoveKPI,
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Branch</TableHead>
          <TableHead>Area</TableHead>
          <TableHead>KPI Name</TableHead>
          <TableHead>Description</TableHead>
          <TableHead>Target</TableHead>
          <TableHead>Quarter</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {goals.map((kpi) => {
          const kpiObj = kpiOptions.find((opt) => opt.id === kpi.kpi) || {
            id: '',
            target_fields: [],
            target_models: [],
            calculation: '',
            description: '',
            title: '',
            area: '',
          }
          const branch = branches.find((b) => b.id === kpi.branch) || {
            id: 0,
            name: '',
            region: 0,
          }
          return (
            <TableRow key={kpi.id}>
              <TableCell>{branch.name}</TableCell>
              <TableCell>{kpiObj.area}</TableCell>
              <TableCell>{kpiObj.title}</TableCell>
              <TableCell>{kpiObj.description}</TableCell>
              <TableCell>{kpi.milestones[0]}</TableCell>
              <TableCell>{`${kpi.year} - Q${kpi.quarter}`}</TableCell>
              <TableCell>
                <Button
                  variant="destructive"
                  onClick={() => handleRemoveKPI(kpi.id)}
                  size="sm"
                >
                  <IconCross />
                </Button>
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}

export default KPITable
